import React from "react";
import { Play } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  
  const handlePlayClick = () => {
    navigate('/game');
  };
  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-cream text-ink font-sans px-6">
      <div className="w-full max-w-xs bg-white rounded-3xl shadow-card px-8 py-10 text-center">
        <div className="w-20 h-20 mx-auto mb-5 rounded-full bg-coral-light flex items-center justify-center">
          <span className="text-4xl" role="img" aria-label="Dharma Wheel">☸️</span>
        </div>
        <h1 className="text-3xl font-extrabold tracking-tight mb-2">Word Wheel</h1>
        <p className="text-ink-muted mb-7">Uncover the hidden word.</p>
        <button
          onClick={handlePlayClick}
          className="bg-coral hover:bg-coral-dark transition-colors text-white font-semibold py-3 px-8 rounded-full mb-6 flex items-center justify-center gap-2 mx-auto shadow-sm"
        >
          <Play size={16} fill="white" />
          Play
        </button>
        <p className="text-xs font-medium tracking-wide text-ink-muted uppercase">{currentDate}</p>
      </div>
    </div>
  );
};

export default Home;
